import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { Statistics } from './campaign-statistics-types';
import CampaignStepBarChart from './campaign-step-bar-chart';

interface Props {
  performanceOfMessages: Statistics | undefined;
  timeZone: string | undefined;
  onBarClick?: (bar: { dateKey: string; stepName: string }) => void;
}

const MessagePerformance: React.FC<Props> = ({ performanceOfMessages, timeZone, onBarClick }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.messagePerformance}>
      <div className={classes.header}>
        <Typography className={classes.titleText} mb={'4px'}>
          {t('yourPerformance')}
        </Typography>
        <Typography className={classes.greyText}>{t('selectMetricToCompare')}</Typography>
      </div>
      <div className={classes.content}>
        <CampaignStepBarChart funnelStatistics={performanceOfMessages} timeZone={timeZone} onBarClick={onBarClick} />
      </div>
    </div>
  );
};

const useStyles = makeStyles()((theme) => ({
  messagePerformance: {
    background: '#FFF',
    borderRadius: '12px',
    overflow: 'hidden',
  },
  header: {
    padding: '20px 24px',
    borderBottom: `1px solid ${theme.palette.greys.lighter}`,
  },
  titleText: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: 500,
  },
  highlight: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
  greyText: {
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.greys.medium,
  },
  content: {
    padding: '24px',
  },
}));

export default MessagePerformance;
